import { Control } from 'react-hook-form';
import { Label } from '../ui/label';
import StyledButton from '../styled/StyledButton';
import StyledInput from '../styled/StyledInput';
import { SupplierFormData } from '@/types/suppliers/SupplierFormData';
import { useTranslation } from 'react-i18next';

interface ContactFromProps {
  index: number;
  control: Control<SupplierFormData>;
  onRemoveContact: () => void;
  disabled?: boolean;
}

const ContactForm = ({
  index,
  control,
  onRemoveContact,
  disabled = false,
}: ContactFromProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex justify-between">
        <Label className="text-gray-700 transition-all duration-200 ease-in-out">
          {t('suppliers.contacts.contact', { index: index + 1 })}
        </Label>
        {index > 0 && !disabled && (
          <StyledButton
            title={t('suppliers.contacts.removeContact')}
            className="p-0 h-auto"
            variant="link"
            onClick={onRemoveContact}
          />
        )}
      </div>
      <StyledInput
        control={control}
        name={`contacts.${index}.name`}
        placeholder={t('suppliers.contacts.name')}
        disabled={disabled}
      />
      <div className="flex flex-col md:flex-row gap-4">
        <StyledInput
          control={control}
          name={`contacts.${index}.email`}
          placeholder={t('suppliers.contacts.email')}
          type="email"
          disabled={disabled}
        />
        <StyledInput
          control={control}
          name={`contacts.${index}.phoneNumber`}
          placeholder={t('suppliers.contacts.phoneNumber')}
          type="tel"
          disabled={disabled}
        />
      </div>
    </>
  );
};

export default ContactForm;
